import * as Types from '../../constants/actionconstants';
const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case Types.FETCH_REPORTENTRIES_REQUEST:
      return {
        ...state,
        report_hours: null,
      };
    case Types.FETCH_REPORTENTRIES_SUCCESS:
      return {
        ...state,
        report_hours: action.payload,
      };
    case Types.FETCH_REPORTENTRIES_FAILURE:
      return {
        ...state,
      };
    default:
      return state;
  }
};
